import GoogleAnalytics from './GoogleAnalytics.jsx';
import Hotjar from './Hotjar.jsx';
import Tapfiliate from './Tapfiliate.jsx';

// Mounts every vendor loader once at the app root. Each loader self-gates on
// its env var + the production host, so this is safe to render everywhere
// (including the pre-auth sign-in screens).
const AnalyticsLoaders = () => (
  <>
    <GoogleAnalytics />
    <Hotjar />
    <Tapfiliate />
  </>
);

export default AnalyticsLoaders;
